import React, { useState } from "react";
import { StylesConfig, components } from "react-select";

import RichContentDisplay from "../../richcontent/RichContentDisplay";
import Badge from "../../text/Badge";

export { default as CountOption } from "./CountOption";

export const OptionWithCheckbox = React.memo(
  ({
    isDisabled,
    isFocused,
    isSelected,
    children,
    innerProps,
    ...rest
  }: React.ComponentProps<typeof components.Option>) => {
    const [isActive, setIsActive] = useState(false);
    const onMouseDown = () => setIsActive(true);
    const onMouseUp = () => setIsActive(false);
    const onMouseLeave = () => setIsActive(false);

    // styles
    let bg = "transparent";
    if (isFocused) bg = "#eee";
    if (isActive) bg = "#B2D4FF";

    const style = {
      alignItems: "center",
      backgroundColor: bg,
      color: "inherit",
      display: "flex",
    };

    // prop assignment
    const innerPropsUpdated = {
      ...innerProps,
      onMouseDown,
      onMouseUp,
      onMouseLeave,
      style,
    };

    return (
      <components.Option
        {...rest}
        isDisabled={isDisabled}
        isFocused={isFocused}
        isSelected={isSelected}
        innerProps={innerPropsUpdated}
      >
        <input type="checkbox" checked={isSelected} readOnly />
        {children}
      </components.Option>
    );
  },
);

export const OptionWithBadge = React.memo(
  ({
    children,
    ...props
  }: React.ComponentProps<typeof components.Option> & {
    data: { badgeCount?: number };
  }) => {
    return (
      <components.Option {...props}>
        {children}
        {props.data.badgeCount != null && (
          // these styles are a hack
          <Badge style={{ float: "right", marginTop: "-3px" }}>
            {props.data.badgeCount > 99 ? "99+" : props.data.badgeCount}
          </Badge>
        )}
      </components.Option>
    );
  },
);

export const RichTextOption = React.memo(
  (props: React.ComponentProps<typeof components.Option>) => {
    return (
      <components.Option {...props}>
        <RichContentDisplay inline content={props.label} />
      </components.Option>
    );
  },
);

export const RichTextSingleValue = React.memo(
  (props: React.ComponentProps<typeof components.SingleValue>) => {
    return (
      <components.SingleValue {...props}>
        <RichContentDisplay inline content={props.children as string} />
      </components.SingleValue>
    );
  },
);

export const selectInputStyles: StylesConfig<any> = {
  control: (styles) => {
    return {
      ...styles,
      minHeight: "30px",
      height: "30px",
      padding: "0 2px",
      borderRadius: "0.3rem",
    };
  },
  clearIndicator: (styles) => {
    return {
      ...styles,
      padding: "4px",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      padding: "4px",
    };
  },
  indicatorsContainer: (styles) => {
    return {
      ...styles,
      padding: "0",
    };
  },
  valueContainer: (styles) => {
    return {
      ...styles,
      height: "28px",
    };
  },
  menuPortal: (styles) => {
    return { ...styles, zIndex: 99999, fontSize: "1.2rem" };
  },
  multiValue: (styles) => {
    return { ...styles, fontSize: "1.2rem" };
  },
};
